import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Icon } from '@ontruck/orc';

const SideBar = ({
  className,
  backLabel,
  redirectRoute,
  children,
  hideLink
}) => {
  return (
    <div className={className} data-testid="side-bar">
      <div className="side-bar">
        {!hideLink && (
          <div className="side-bar__link" data-testid="side-bar__link">
            <Link
              className="side-bar__back"
              to={location => ({ ...location, pathname: redirectRoute })}
            >
              <Icon glyph="previous" size="1rem" />
              {backLabel}
            </Link>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

SideBar.defaultProps = {
  redirectRoute: '',
  hideLink: false
};

SideBar.propTypes = {
  backLabel: PropTypes.string.isRequired,
  redirectRoute: PropTypes.string,
  hideLink: PropTypes.bool
};

export default SideBar;
